import React, { Component } from 'react';
import { string, any, object } from 'prop-types';
import styled, { css } from 'styled-components';
import { includes } from 'lodash';
import withTranslation from '../../../hoc/withTranslation';

class Text extends Component {
    static propTypes = {
        renderAs: string,
        children: any,
        text: any,
        style: object
    }

    static defaultProps = {
        text: 'text',
        renderAs: 'span',
        strong: false
    }

    render () {
        const { text, renderAs, children, style, ...props } = this.props;
        const textContent = includes(['undefined', 'null', 'Number'], typeof text) ? String(text) : text;

        const TextComponent = styled(renderAs)`
            font-weight: normal;

            ${({ italic }) => italic && css`
                font-style: italic;
            `}

            ${({ size = 12 }) => size && css`
                font-size: ${parseInt(size) / 16}rem;
            `}

            ${({ heading }) => heading && css`
                font-size: 1.2rem;
            `}


            ${({ subtitle }) => subtitle && css`
                font-size: 0.68rem;
                color: #848484;
            `}

            ${({ tiny }) => tiny && css`
                font-size: 0.59rem;
                color: black;
            `}

            ${({ strong = 'normal' }) => strong && css`
                font-weight: ${strong ? 'bold' : 'normal'};
            `}

            ${({ inherit }) => inherit && css`
                font-weight: inherit;
            `}

            ${({ semibold }) => semibold && css`
                font-weight: 600;
            `}

            ${({ uppercase, capitalize }) => (uppercase || capitalize) && css`
                text-transform: ${capitalize ? 'capitalize' : 'uppercase'};
            `}

            ${({ color = '#333333' }) => color && css`color: ${color};`}

            ${({ centered }) => centered && css`
                text-align: center;
            `}

            ${({ align }) => align && css`
                text-align: ${align};
            `}

            ${({ lineHeight }) => lineHeight && css`
                line-height: ${lineHeight};
            `}

            ${({ nowrap }) => nowrap && css`
                white-space: nowrap;
            `}

            ${({ cursor }) => cursor && css`cursor: ${cursor};`}

            :hover {
                ${({ colorHover }) => colorHover && `color: ${colorHover};`}
                ${({ underlineOnHover }) => underlineOnHover && `text-decoration: underline;`}
            }

            ${({ padding, paddingVertical, paddingHorizontal, paddingTop, paddingRight, paddingBottom, paddingLeft }) => `
                padding:
                    ${padding || paddingVertical || paddingTop || 0}px
                    ${padding || paddingHorizontal || paddingRight || 0}px
                    ${padding || paddingVertical || paddingBottom || 0}px
                    ${padding || paddingHorizontal || paddingLeft || 0}px;
            `}

            ${({ truncate }) => truncate && css`
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: fit-content;
            `}

            ${({ borderBottom }) => borderBottom && css`border-bottom: ${borderBottom};`}

            ${({ minWidth }) => minWidth && css`min-width: ${minWidth}px;`}
        `;

        return (
            <TextComponent style={style} {...props}>
                {textContent || children}
            </TextComponent>
        );
    }
}

export default withTranslation(Text, ['text', 'children']);
